/**
 * The ONE definition of the `getRoundChecklist` query key.
 *
 * Same reasoning as `videoStateQueryInput`, and the same failure if it drifts:
 * the rail READS this entry while the mark writes patch it optimistically. A
 * reader and a writer that build the input differently get separate cache
 * entries, so a tick would appear to do nothing until a refetch.
 *
 * `viewAsUserId` is a client-side cache discriminator only — the server scopes
 * by `ctx.getUser()` and ignores it — so it must be `undefined`, not a real
 * user id, when nobody is being impersonated.
 */
export function todoChecklistQueryInput(
  roundId: string,
  viewAsUserId: string | null,
): { roundId: string; viewAsUserId: string | undefined } {
  return { roundId, viewAsUserId: viewAsUserId ?? undefined };
}
